import script from "./TimezoneCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./TimezoneCalculator.vue?vue&type=script&setup=true&lang=js"

import "./TimezoneCalculator.vue?vue&type=style&index=0&id=6bdae983&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bdae983"]])

export default __exports__